<template>
	<div class="fixed inset-y-0 right-0 pl-10 flex side-over w-720 z-50">
		<div
			class="h-full w-full flex flex-col bg-white shadow-xl"
			style="min-height: 100vh; height: fit-content"
		>
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center gap-2">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M13.6303 5.68726L15.8833 3.43422C16.7491 2.56844 17.182 2.13555 17.689 1.99477C18.0391 1.89758 18.4091 1.89758 18.7591 1.99477C19.2662 2.13555 19.6991 2.56844 20.5649 3.43423C21.4306 4.30001 21.8635 4.7329 22.0043 5.23996C22.1015 5.59003 22.1015 5.95997 22.0043 6.31005C21.8635 6.81711 21.4306 7.25 20.5649 8.11578L18.338 10.3427C16.3854 9.22291 14.7646 7.6144 13.6303 5.68726ZM12.1759 7.14163L3.86541 15.4521C3.44035 15.8772 3.22782 16.0897 3.08808 16.3508C2.94835 16.6119 2.8894 16.9066 2.77151 17.4961L1.98573 21.425C1.9192 21.7576 1.88594 21.9239 1.98055 22.0185C2.07516 22.1131 2.24145 22.0799 2.57404 22.0134L2.57406 22.0134L2.57408 22.0134L6.503 21.2276L6.50302 21.2276C7.09246 21.1097 7.38718 21.0507 7.64828 20.911C7.90937 20.7713 8.1219 20.5587 8.54695 20.1337L8.54696 20.1337L16.8798 11.8008C14.9781 10.6167 13.3718 9.02142 12.1759 7.14163Z"
								fill="#94A3B8"
							/>
						</svg>

						<div class="text-4xl font-bold text-neutral-700 ml-1.5">
							Chỉnh sửa
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div
				class="
					bg-white
					shadow-sm
					rounded-2xl
					overflow-hidden
					sideover-content
					p-6
				"
			>
				<div class="border-b border-neutral-200 mb-8">
					<div class="flex space-x-8 tabs">
						<div
							v-for="(t, index) in tabs"
							:key="index"
							class="
								border-transparent
								hover:text-yellow-700 hover:border-yellow-500
								text-neutral-500
								whitespace-nowrap
								py-3
								px-1
								border-b-2
								font-semibold
								cursor-pointer
							"
							:class="{
								'tab-active': tab === index,
							}"
							@click="tab = index"
						>
							<div class="flex items-center gap-2">
								<div>{{ t.name }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-color" v-if="tab === 0">
					<div class="text-sm text-neutral-600 font-semibold">
						Chọn khoảng kết quả cho
						<span class="text-yellow-700">Mục tiêu lặp lại</span>
					</div>
					<div class="slider-container">
						<input
							type="range"
							:min="minLimit"
							:max="maxLimit"
							v-model="min"
							step="5"
							@input="handleMinInput"
						/>
						<input
							type="range"
							:min="minLimit"
							:max="maxLimit"
							v-model="max"
							step="5"
							@input="handleMaxInput"
						/>
						<div class="slider-track">
							<div
								class="segment red"
								:style="{ width: redLeft + '%' }"
							></div>
							<div
								class="segment active"
								:style="{
									left: redLeft + '%',
									width: activeWidth + '%',
								}"
							></div>
							<div
								class="segment green"
								:style="{
									left: redLeft + activeWidth + '%',
									width: greenWidth + '%',
								}"
							></div>
						</div>
						<div class="flex items-center font-semibold w-full">
							<div
								class="min-value"
								:style="{
									left:
										((min - minLimit) /
											(maxLimit - minLimit)) *
											100 -
										1 +
										'%',
								}"
							>
								{{ min }}
							</div>

							<div
								class="max-value"
								:style="{
									right:
										99 -
										((max - minLimit) /
											(maxLimit - minLimit)) *
											100 +
										'%',
								}"
							>
								{{ max }}
							</div>
						</div>
					</div>

					<div
						class="
							flex
							items-center
							justify-between
							font-semibold
							mt-6
							w-full
						"
					>
						<div style="color: #f87171">Tạm dừng MT</div>
						<!-- <div class="text-middle">Lặp lại MT</div> -->
						<div style="color: #2aa797">Hoàn thành MT</div>
					</div>
				</div>
				<div class="font-semibold text-color" v-if="tab === 1">
					<div class="text-sm text-neutral-600 mb-1">Mặc định</div>
					<Multiselect
						deselect-label="Đã chọn"
						track-by="name"
						:options="
							dropdown?.map((s) => {
								return {
									nameSearch: toEnglish(s?.name),
									...s,
								};
							})
						"
						v-model="plan"
						:searchable="true"
						label="nameSearch"
						:allow-empty="false"
						selectLabel=""
						placeholder="Chọn quyết định"
					>
						<template #noResult> Không tìm thấy kết quả </template>
						<template v-slot:option="props">
							<div class="flex flex-nowrap items-center">
								<div>
									{{ props.option.name }}
								</div>
							</div>
						</template>
						<template v-slot:singleLabel="{ option }">
							<div
								class="
									flex flex-nowrap
									items-center
									font-medium
								"
							>
								<div>{{ option.name }}</div>
							</div>
						</template>
					</Multiselect>
				</div>
			</div>
			<div class="px-6 py-4">
				<div class="flex justify-end">
					<button
						class="
							button-p
							text-center
							whitespace-nowrap
							w-fit
							md-down:hidden
						"
						type="button"
						@click="confirm"
					>
						Xác nhận
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch, computed } from 'vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { toEnglish } from '@/helper/toEnglish';
import { $api } from '@/services';
import { useStore } from 'vuex';

const emit = defineEmits(['close']);
const props = defineProps([
	'endPercent',
	'startPercent',
	'nextPlan',
	'sideOverShow',
]);
const store = useStore();
const tabs = ref([
	{
		name: 'Mục tiêu có kết quả',
	},
	{
		name: 'Mục tiêu chưa dạy',
	},
]);
const tab = ref(0);

const plan = ref({
	name: 'Lặp lại mục tiêu',
	value: 'continued',
});
const dropdown = ref([
	{
		name: 'Lặp lại mục tiêu',
		value: 'continued',
	},
	{
		name: 'Tạm dừng mục tiêu',
		value: 'stopped',
	},
]);
const minLimit = 5;
const maxLimit = 95;

const min = ref(props.startPercent);
const max = ref(props.endPercent);

const redLeft = computed(
	() => ((min.value - minLimit) / (maxLimit - minLimit)) * 100
);
const activeWidth = computed(
	() => ((max.value - min.value) / (maxLimit - minLimit)) * 100
);
const greenWidth = computed(() => 100 - redLeft.value - activeWidth.value);

watch(
	() => props.sideOverShow,
	() => {
		plan.value = dropdown.value.find((i) => i.value === props.nextPlan);
	}
);
watch(
	() => props.startPercent,
	(value) => {
		min.value = value;
	}
);
watch(
	() => props.endPercent,
	(value) => {
		max.value = value;
	}
);

// Ensure values don't overlap
const handleMinInput = () => {
	if (min.value > max.value - 4) {
		min.value = max.value - 5;
	}
};

const handleMaxInput = () => {
	if (max.value < min.value + 4) {
		max.value = min.value + 5;
	}
};
async function confirm() {
	try {
		let data = {
			auto_fill_assessment_report_form: {
				end_percent: max.value,
				next_plan_for_unlearned_goal: plan.value.value,
				start_percent: min.value,
			},
		};
		await $api.org.autoFill(data);
		emit('submit');
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}
</script>
<style scoped>
.w-720 {
	width: 720px !important;
}
.sideover-content {
	height: calc(100vh - 179px);
	overflow-y: auto;
	padding-bottom: 100px;
}
.text-color {
	color: #48566a;
}
.tab-active {
	color: #d89210;
	border-color: #f0bb4f !important;
}
.price-range {
	max-width: 400px;
	margin: auto;
	padding: 1rem;
	border: 1px solid #ccc;
	border-radius: 12px;
	background-color: #f9f9f9;
}

.slider-container {
	position: relative;
	height: 40px;
	margin-top: 1rem;
}

input[type='range'] {
	position: absolute;
	width: 100%;
	pointer-events: none;
	-webkit-appearance: none;
	background: transparent;
	z-index: 2;
}

input[type='range']::-webkit-slider-thumb {
	pointer-events: auto;
	width: 18px;
	height: 18px;
	background: #f0bb4f;
	border-radius: 50%;
	border: none;
	-webkit-appearance: none;
}

.slider-track {
	position: absolute;
	width: 100%;
	height: 6px;
	top: 25%;
	transform: translateY(-50%);
	background: #ddd;
	border-radius: 4px;
	z-index: 1;
}
.segment {
	position: absolute;
	height: 100%;
	top: 0;
}

.segment.red {
	background-color: #f87171;
	left: 0;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.segment.active {
	background-color: #f0bb4f;
}

.segment.green {
	background-color: #2aa797;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
}

.price-display {
	text-align: center;
	margin-top: 1rem;
	font-weight: bold;
}
.min-value {
	color: #f87171;
	position: absolute;
	top: 30px;
}

.max-value {
	color: #2aa797;
	position: absolute;
	top: 30px;
}
.text-middle {
	color: #d89210;
}
</style>
